import { useServiceData } from "@/hooks/useServiceData";
import { ServiceCard } from "@/components/service/ServiceCard";
import { SectionHeader } from "@/components/ui/SectionHeader";

export const Services = () => {
  const { services, isLoading } = useServiceData();

  if (isLoading) {
    return (
      <section className="relative z-30 py-20 bg-gradient-sky">
        <div className="container mx-auto px-4 text-center">
          <p className="text-muted-foreground">Chargement des services...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="relative z-30 py-20 bg-gradient-sky">
      <div className="container mx-auto px-4">
        
        <SectionHeader
          badge="Nos Services"
          title="Nos Attractions"
          description="Découvrez notre gamme complète de châteaux gonflables et sumos, parfaits pour créer des souvenirs inoubliables lors de vos événements."
        />

        {/* Services Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>

      </div>
    </section>
  );
};